import React from 'react';
import { motion } from 'framer-motion';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-247" data-mp="3utm4aq96wfw5">
      <div className="mx-auto max-w-5xl" data-id="element-248" data-mp="co92kz3oayh2">
        <div className="mx-auto max-w-2xl text-center" data-id="element-249" data-mp="cnzbt9at0nab">
          <h2 className="font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-250" data-mp="7po537ft2swb">
            7 kompletnych tomów
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-251" data-mp="3g5raf6jg45hh">
            Spójna kolejność tematów — od budowy atomu po doświadczenia laboratoryjne.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-252" data-mp="3pw2qtskbg759">
          {volumes.map((volume, i) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-chem/20 bg-white p-5 shadow-sm shadow-chem/5 sm:gap-6 sm:p-6" data-id="element-253" data-mp="3l3j0rw4fzjjk" data-mpi={i}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-254" data-mp="2ec8tbcp4mtol">
                <span className="font-display text-3xl font-bold leading-none text-chem sm:text-4xl" data-id="element-255" data-mp="2j6mu5umk5t0n">
                  {volume.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-256" data-mp="1qgwdpexgef1d">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-257" data-mp="1vg976iitykcx">
                  {volume.description}
                </p>
                <div className="mt-auto pt-5" data-id="element-258" data-mp="24gfjw26pfgb1">
                  <span className="inline-block rounded-full bg-chem/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-chem-deep" data-id="element-259" data-mp="24h73sfqxvplh">
                    W cenie pakietu
                  </span>
                </div>
              </div>
              <div className="shrink-0 self-start" data-id="element-260" data-mp="1gqsw6t9a5vxv">
                <img src={volume.cover} alt={`Okładka tomu ${volume.number}: ${volume.title}`} loading="lazy" className="block h-[130px] w-[96px] object-contain drop-shadow-[0_10px_18px_rgba(11,29,58,0.18)] sm:h-[190px] sm:w-[140px]" data-id="element-261" data-mp="1gphxh7uozedm" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}